import L from "leaflet";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet/dist/leaflet.css";
import { useEffect, useRef } from "react";
import { MapContainer, TileLayer, ZoomControl, useMap } from "react-leaflet";
import motoIcon from "../../../assets/Icon/MOTO.png";
import LocateButton from "./LocateButton";

const vehicleIcons = { MOTO: motoIcon };

const createVehicleIcon = (gps) => {
  const iconSrc = vehicleIcons[gps.gps?.type] || motoIcon;

  const iconHtml = `
    <div style="
      display: flex;
      flex-direction: column;
      align-items: center;
    ">

    <div style="
        background: white;
        padding: 2px 6px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: bold;
        white-space: nowrap;
        box-shadow: 0 1px 4px rgba(0,0,0,0.3);
      ">
        ${gps.gps.nom}
      </div>

      <!-- 🔥 ICON -->
      <div style="
        transform: rotate(${gps.course ?? 0}deg);
        transition: transform 0.3s linear;
        margin-top: -5px;
      ">
        <img src="${iconSrc}" width="40" height="40"/>
      </div>
    </div>
  `;

  return L.divIcon({
    html: iconHtml,
    iconSize: [35, 35],
    iconAnchor: [17, 17],
    className: "vehicle-icon",
  });
};

// Composant enfant pour gérer les markers
function VehicleMarkers({ gpsDataList, openPetitDetail }) {
  const map = useMap();
  const markersGroupRef = useRef(L.markerClusterGroup());

  useEffect(() => {
    if (!map) return;

    const markersGroup = markersGroupRef.current;
    markersGroup.clearLayers();

    gpsDataList.forEach((gps) => {
      if (gps.latitude && gps.longitude) {
        const marker = L.marker([gps.latitude, gps.longitude], {
          icon: createVehicleIcon(gps),
        });
        marker.on("click", () => {
          map.flyTo([gps.latitude, gps.longitude], 17, { duration: 2 });
          openPetitDetail(gps);
        });
        markersGroup.addLayer(marker);
      }
    });

    markersGroup.addTo(map);

    return () => markersGroup.clearLayers();
  }, [map, gpsDataList, openPetitDetail]);

  return null;
}

// Hook pour centrer et zoomer
function ZoomTo({ position }) {
  const map = useMap();

  useEffect(() => {
    if (position?.latitude != null && position?.longitude != null) {
      map.flyTo([position.latitude, position.longitude], 17, { duration: 2 });
    }
  }, [position, map]);

  return null;
}

function MapComponent({ gpsDataList, openPetitDetail, zoomerActionData }) {
  const center = [12.6392, -8.0029];

  return (
    <MapContainer
      center={center}
      zoom={13}
      maxZoom={18}
      zoomControl={false}
      style={{ height: "100%", width: "100%" }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />
      <ZoomControl position="topright" />
      <LocateButton />
      <ZoomTo position={zoomerActionData} />
      <VehicleMarkers gpsDataList={gpsDataList} openPetitDetail={openPetitDetail} />
    </MapContainer>
  );
}

export default MapComponent;